import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=1294e87c&"
import script from "./InputTextarea.vue?vue&type=script&lang=ts&"
export * from "./InputTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports